import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppValidationsHelper } from '../../../../../admin/src/app/app-validations.helper';
import { RoutingStateService } from '../../services/routing-state.service';
import { AuthService } from '../../../../../admin/src/app/services/auth.service';
import { UserService } from '../../../../../admin/src/app/services/user.service';
import { LanguageService } from '../../services/language.service';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  form: FormGroup;

  sub: Subscription;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private routingState: RoutingStateService,
    private authSvc: AuthService,
    private userSvc: UserService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Login');

    this.form = this.fb.group({
      email: [null, Validators.required],
      password: [null, Validators.required]
    });
  }

  login() {
    this.form.markAsDirty();
    this.form.markAsTouched();

    if (this.form.valid) {
      let credentials = this.form.value;
      this.authSvc.access(credentials).subscribe(data => {
        this.userSvc.getCurrentUser().subscribe(() => {
          this.afterLogin();
        });
      },
      error => {
        if (error.code === 2) {
          this.form.setErrors({ unauthorized: true });
        } else if (error.code === 0) {
          this.form.setErrors({ noconnection: true });
        } else {
          this.form.setErrors({ unavailable: true });
        }
      });
    } else {
      AppValidationsHelper.validateFormFields(this.form);
    }

    return false;
  }

  afterLogin() {
    let previousUrl = this.routingState.getPreviousUrl();
    if (previousUrl.includes('/register') || previousUrl.includes('/login')) {
      previousUrl = '/' + this.language.getLang();
    }
    this.router.navigate([previousUrl]);
  }

}
